import { faBuilding } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const BuildingIcon = (props: { color: string }) => {
  return (
    <FontAwesomeIcon icon={faBuilding} color={props.color} />
  )
}
